import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';

export const useUser = () => {
    const {
        data: user,
        isLoading: isLoadingUser
    } = useQuery({
        queryKey: ['user'],
        queryFn: async () => {
            const result = await container.authRepository.getCurrentUser();
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        }
    });


    return {
        user,
        isLoading: isLoadingUser
    };
}; 